import { mpx } from '@didi/es-mpx-creator'
import { getTrainCityList, getTrainCityListByKeyword } from '@/api/city'
import { query, hashQuery } from '@didi/webx-js';
import { parser } from '@didi/trip-service-utils';
const myQuery = () => {
  return { ...query(), ...hashQuery() };
};

export default {
  async setDefaultCityList({ state, commit, dispatch }, cityId) {
    const { from, fromCity, toCity } = myQuery();
    if (from === 'outside') {
      const fromCityObj = fromCity ? parser.parse(fromCity) : {};
      const toCityObj = toCity ? parser.parse(toCity) : {};
      const {
        name: from_station_name,
        city_id: from_city_id,
        city_name: from_city_name,
        precise_search: from_precise_search
      } = fromCityObj;
      const {
        name: to_station_name,
        city_id: to_city_id,
        city_name: to_city_name,
        precise_search: to_precise_search
      } = toCityObj;
      const fromCityReal = {
        id: from_city_id,
        name: from_station_name,
        precise_search: from_precise_search,
        subName: from_city_name
      };
      const toCityReal = {
        id: to_city_id,
        name: to_station_name,
        precise_search: to_precise_search,
        subName: to_city_name
      };
      commit('changeSelectCityList', {
        type: 'currentFromCity',
        data: fromCityReal
      })
      commit('changeSelectCityList', {
        type: 'currentToCity',
        data: toCityReal
      });
    }else{
      const LAST_SEARCH_CITY_LIST = state.historyList?.[0];
      if (LAST_SEARCH_CITY_LIST?.length === 2) return;
      let currentFromCity = state.DEFAULT_FROM_CITY,
        currentToCity = state.DEFAULT_TO_CITY;

      if (cityId) {
        await dispatch('getTrainCityList');
        const citys = state.trainCities.reduce((cityMap, item) => {
          item.city_list.forEach(({ city_id, city_name }) => {
            cityMap[city_id] = city_name;
          });
          return cityMap;
        }, {});
        citys[cityId] &&
          (currentFromCity = {
            id: cityId,
            name: citys[cityId],
            subName: citys[cityId],
            precise_search: '0'
          });
      }
      commit('changeSelectCityList', {
        type: 'currentFromCity',
        data: currentFromCity
      });
      commit('changeSelectCityList', {
        type: 'currentToCity',
        data: currentToCity
      });
    }
  },
  getTrainCityList({ state, commit }, options) {
    return getTrainCityList({ state, commit }, options).then(res => {
      const { data, code } = res || {}
      if (data || code == '0') {
        commit('setAllTrainCityList', { ...data })
      }
      return res
    })
  },
  getTrainCityListByKeyword({ state, commit }, options) {
    mpx.showLoading()
    return getTrainCityListByKeyword(options).then(res => {
      const { data, code } = res || {}
      if (data || code == '0') {
        commit('setSearchedCity', { ...data })
      }
      return res
    }).finally(() => {
      mpx.hideLoading()
    })
  }

}
